import { useState, useCallback } from 'react';

/**
 * useCelebration — reusable hook for triggering badge/milestone/completion celebrations.
 *
 * Usage:
 *   const { celebration, triggerBadge, triggerStreak, triggerPlayComplete, dismissCelebration } = useCelebration();
 *
 * celebration shape:
 *   { type: 'badge' | 'streak' | 'play_complete', badge?, streakDays?, playTitle? }
 */
const useCelebration = () => {
  const [celebration, setCelebration] = useState(null);

  const triggerBadge = useCallback((badge) => {
    setCelebration({ type: 'badge', badge });
  }, []);

  const triggerStreak = useCallback((streakDays) => {
    setCelebration({ type: 'streak', streakDays });
  }, []);

  const triggerPlayComplete = useCallback((playTitle) => {
    setCelebration({ type: 'play_complete', playTitle });
  }, []);

  const dismissCelebration = useCallback(() => {
    setCelebration(null);
  }, []);

  return { celebration, triggerBadge, triggerStreak, triggerPlayComplete, dismissCelebration };
};

export default useCelebration;
